// Minimal, safe polyfills for older mobile browsers / WebViews.
// Runs before app code (imported at top of src/main.tsx) so that any
// downstream call to Array.prototype.at (from us or a dependency) works
// on iOS < 15.4 / Android WebViews < 92 without crashing the app.

if (typeof Array.prototype.at !== "function") {
  
  Object.defineProperty(Array.prototype, "at", {
    configurable: true,
    writable: true,
    value: function at(this: unknown[], n: number) {
      const len = this.length >>> 0;
      let i = Math.trunc(n) || 0;
      if (i < 0) i += len;
      if (i < 0 || i >= len) return undefined;
      return this[i];
    },
  });
}

// String.prototype.at — same era as Array#at; polyfill defensively.
if (typeof String.prototype.at !== "function") {
  Object.defineProperty(String.prototype, "at", {
    configurable: true,
    writable: true,
    value: function at(this: string, n: number) {
      const len = this.length;
      let i = Math.trunc(n) || 0;
      if (i < 0) i += len;
      if (i < 0 || i >= len) return undefined;
      return this.charAt(i);
    },
  });
}

export {};
